import { type InferType, object, string } from "yup";

export enum BankDetailsInputFields {
  InstitutionNumber = "institutionNumber",
  TransitNumber = "transitNumber",
  BankName = "bankName",
  BankCountry = "bankCountry",
  BankCountryValidatedCountry = "bankCountryValidatedCountry",
}

export const EftBankDetailsInputSchema = object().shape({
  [BankDetailsInputFields.InstitutionNumber]: string()
    .required("Required field")
    .matches(/^[0-9]*$/, "Institution number must contain only digits")
    .matches(/^[0-9]{3}$/, "Institution number must be exactly 3 digits"),
  [BankDetailsInputFields.TransitNumber]: string()
    .required("Required field")
    .matches(/^[0-9]*$/, "Transit number must contain only digits")
    .matches(/^[0-9]{5}$/, "Transit number must be exactly 5 digits"),
  [BankDetailsInputFields.BankName]: string()
    .required("Required field")
    .max(100, "Must be 100 characters or less")
    .matches(/\S/, "Bank name cannot be just spaces."),
  [BankDetailsInputFields.BankCountry]: string(),
  [BankDetailsInputFields.BankCountryValidatedCountry]: string().optional(),
});

export type EftBankDetailsInputType = InferType<typeof EftBankDetailsInputSchema>;
